import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import Logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StylesContext } from "@insite/content-library/additionalStyles";
import NavigationDrawer from "@insite/content-library/Components/NavigationDrawer";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconProps, IconWrapper } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import { PopoverPresentationProps, PositionStyle } from "@nishtech/Components/OSBPHeaderPopoverV2";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp, resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomCategoryModel } from "@nishtech/Services/Models/CustomApiModels";
import * as cssLinter from "css";
import parse from "html-react-parser";
import isEqual from "lodash/isEqual";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import NishtechColors from "@nishtech/Utils/NishtechColors";
import Hidden from "@insite/mobius/Hidden";
import MainNavigationItem from "@nishtech/Overrides/Components/MainNavigationItem";
const enum fields {
    links = "links",
    showQuickOrder = "showQuickOrder",
    customCSS = "customCSS",
    enableCustomMegaMenu = "enableCustomMegaMenu",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.showQuickOrder]: boolean;
        [fields.customCSS]: string;
        [fields.enableCustomMegaMenu]: boolean;
    };
    isCompactHeaderFlyoutMenu: boolean;
    flyoutCustomCSS?: string;
    isCompactHeaderMainNavigation: boolean;
    сompactHeaderMainNavigationCustomCSS?: string;
}

interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        isLoggedInRequired: boolean;
        mergedTwoCategoryIntoOne: boolean;
        megaMenuName: string;
        destination: LinkFieldValue;
        linkType: "Link" | "MegaMenu" | "CascadingMenu";
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        maxDepth: number;
        isCalloutMenu: boolean;
        hasCalloutBox: boolean;
        callOutTitle: string;
        callOutText: string;
        isCustomMegaMenu?:boolean;
        megaMenuType:string;
        megaMenuWidth:string;
        megaMenuHeight:string;
        allowMultipleWidget:boolean;
        firstContainerWidth:string;
        secondContainerWidth:string;
        thirdContainerWidth:string;
    };
}

export interface MappedLink {
    categoryId?: string;
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    isLoggedInRequired?: boolean;
    mergedTwoCategoryIntoOne?: boolean;
    megaMenuName?: string;
    numberOfColumns?: number;
    maxDepth?: number;
    isCalloutMenu?: boolean;
    hasCalloutBox?: boolean;
    callOutTitle?: string;
    callOutText?: string;
    childrenType?: "MegaMenu" | "CascadingMenu" | "CustomLinkList";
    children?: MappedLink[];
    properties?: any;
    newProductCategories?: CustomCategoryModel[] | null;
    shopProductSubCat?: CustomCategoryModel[] | null;
    isCustomMegaMenu?:boolean;
    megaMenuType?:string;
    megaMenuWidth?:string;
    megaMenuHeight?:string;
    allowMultipleWidget?:boolean;
    firstContainerWidth?:string;
    secondContainerWidth?:string;
    thirdContainerWidth?:string;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    let mappedLinks = [];
    const categoryIdsToLoad: Dictionary<number> = {};
    const newProductCategory = getCategoriesDataView(state).value?.filter(p => p?.name === "New Product")[0];
    for (const link of links) {
        const {
            fields: { linkType, destination, openInNewWindow, overrideTitle, numberOfColumns, maxDepth, title,
                isLoggedInRequired,
                mergedTwoCategoryIntoOne,
                megaMenuName,isCalloutMenu, hasCalloutBox, callOutText, callOutTitle,isCustomMegaMenu,megaMenuType,allowMultipleWidget,megaMenuWidth,megaMenuHeight,
                firstContainerWidth,secondContainerWidth,thirdContainerWidth},
        } = link;
        const { type, value } = destination;
        const newProductSubCategories = newProductCategory?.subCategoryIds?.map(
            item => getCategoryState(state, item).value,
        );
        const depthToLoad = linkType === "MegaMenu" ? 3 : maxDepth;

        let mappedLink: MappedLink | undefined;

        if (type === "Url") {
            mappedLink = {
                url: value,
                title,
            };
        } else if (type === "Page") {
            const readonlyPageLink = getPageLinkByNodeId(state, value);
            if (readonlyPageLink) {
                mappedLink = { ...readonlyPageLink };
                if (overrideTitle) {
                    mappedLink.title = overrideTitle;
                }
            }
        } else if (type === "Category") {
            mappedLink = setupCategoryLink(
                state,
                value,
                categoryIdsToLoad,
                depthToLoad,
                overrideTitle,
                state.data.categories.categoryIdsCalled,
            );
        }

        if (!mappedLink) {
            continue;
        }

        mappedLink.openInNewWindow = openInNewWindow;
        mappedLink.isLoggedInRequired = isLoggedInRequired;
        mappedLink.mergedTwoCategoryIntoOne = mergedTwoCategoryIntoOne;
        mappedLink.megaMenuName = megaMenuName;
        mappedLink.numberOfColumns = numberOfColumns;
        mappedLink.maxDepth = maxDepth;
        mappedLink.newProductCategories = newProductSubCategories as unknown as CustomCategoryModel[];
        mappedLink.isCalloutMenu =isCalloutMenu;
        mappedLink.hasCalloutBox = hasCalloutBox;
        mappedLink.callOutText=callOutText;
        mappedLink.callOutTitle=callOutTitle;
        mappedLink.isCustomMegaMenu=isCustomMegaMenu;
        mappedLink.megaMenuType=megaMenuType;
        mappedLink.megaMenuWidth=megaMenuWidth;
        mappedLink.megaMenuHeight=megaMenuHeight;
        if (linkType === "MegaMenu" || linkType === "CascadingMenu") {
            mappedLink.childrenType = linkType;
        }

        if(mappedLink.title === "Brands" && mappedLink.children )
        {
            const childLink : any = mappedLink?.children?.map(item=> {          
            if( item.title === "Shop All Brands" || item.title === "Featured Brands"){
                return {...item,children:null};
            } 
            return item;
          }).filter(item=>{
            return ["Shop Products","Deals Center"].includes(item.title)===false;
          })
            mappedLinks.push({...mappedLink, children: childLink});
        } else {
            mappedLinks.push(mappedLink);
        }
    }

    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const orderSettings = getSettingsCollection(state).orderSettings;
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;

     let customerNumber = "";
    const billToId = state.context.session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }

    mappedLinks = mappedLinks.map(eachLink => {
        if (eachLink.title === "Brands") {
            return {
                ...eachLink,
                children: eachLink?.children?.filter((eachChild : any) => {
                    return eachChild.url !== "/catalog/shopproducts";
                }),
            };
        }
        return eachLink;
    });
    
    return {
        links: mappedLinks,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        displayVmiNavigation:
            currentMode === "Vmi" &&
            orderSettings.vmiEnabled &&
            isAuthenticated &&
            session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1,
        displayModeSwitch:
            isAuthenticated && orderSettings.vmiEnabled && session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1,
        currentMode,
        session: state.context.session,
        categories: state.data.categories,
        categoriesDataView: getCategoriesDataView(state),
        newProductCategory,
        customerNo: customerNumber,
        vmiPageLinks: [
            getPageLinkByPageType(state, "VmiDashboardPage"),
            getPageLinkByPageType(state, "VmiLocationsPage"),
            getPageLinkByPageType(state, "VmiUsersPage"),
            getPageLinkByPageType(state, "VmiBinsPage"),
            getPageLinkByPageType(state, "VmiReportingPage"),
            getPageLinkByPageType(state, "VmiOrderHistoryPage"),
        ],
    };
};

const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
});

const setupCategoryLink = (
    state: ApplicationState,
    value: string,
    categoryIdsToLoad: Dictionary<number>,
    maxDepth: number,
    overrideTitle: string,
    categoryIdsCalled: string[],
) => {
    let mappedLink: MappedLink | undefined;

    if (!value) {
        return;
    }

    const depthLoaded = getCategoryDepthLoaded(state, value);
    const subCategoryIds = getSubCategoryIds(state, value);
    if (
        (depthLoaded < maxDepth || (!subCategoryIds && !categoryIdsCalled?.includes(value))) &&
        !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
    ) {
        categoryIdsToLoad[value] = maxDepth;
    } else {
        if (value === emptyGuid) {
            mappedLink = {
                url: "",
                title: overrideTitle || translate("Products"),
            };
        } else {
            const categoryState = getCategoryState(state, value);
            if (!categoryState.value) {
                if (
                    !categoryState.isLoading &&
                    !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
                ) {
                    categoryIdsToLoad[value] = maxDepth;
                }
                return;
            }
            mappedLink = {
                url: categoryState.value.path,
                title: overrideTitle || categoryState.value.shortDescription,
                properties: categoryState.value.properties,
            };
        }

        loadSubCategories(mappedLink, subCategoryIds, 1, maxDepth, state);
    }

    return mappedLink;
};

const loadSubCategories = (
    mappedLink: MappedLink,
    subCategoryIds: readonly string[] | undefined,
    currentDepth: number,
    maxDepth: number,
    state: ApplicationState,
) => {
    if (currentDepth > maxDepth) {
        return;
    }
    mappedLink.children = [];
    if (!subCategoryIds) {
        return;
    }
    for (const subCategoryId of subCategoryIds) {
        const subCategory = getCategoryState(state, subCategoryId).value;
        if (!subCategory) {
            Logger.error(`Category ${subCategoryId} was not found in data state, excluding from navigation.`);
            continue;
        }
        const childLink: MappedLink = {
            url: subCategory.path,
            title: subCategory.shortDescription,
            children: [],
            properties: subCategory.properties,
        };
        mappedLink.children.push(childLink);

        loadSubCategories(childLink, subCategory.subCategoryIds, currentDepth + 1, maxDepth, state);
    }
};

const mapDispatchToProps = {
    loadCategories,
    // toggleLoginDrawer,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface State {
    selectedLinkIndex?: number;
    mobileSearchModalIsOpen: boolean;
}

export interface MainNavigationStyles {
    menuHeight: number;
    container?: InjectableCss;
    itemWrapper?: InjectableCss;
    quickOrderItemWrapper?: InjectableCss;
    menuItem?: InjectableCss;
    menuItemIcon?: IconProps;
    menuItemTypography?: TypographyPresentationProps;
    cascadingMenu?: MenuPresentationProps;
    megaMenu?: PopoverPresentationProps;
    megaMenuGridContainer?: GridContainerProps;
    megaMenuGridItem?: GridItemProps;
    megaMenuHeading?: LinkPresentationProps;
    megaMenuLink?: LinkPresentationProps;
    mobileWrapper?: InjectableCss;
    compactFlyoutMenu?: InjectableCss;
    mobileMenuWrapper?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchInputWrapper?: InjectableCss;
    mobileSearchInputStyles?: SearchInputStyles;
    mobileSearchModalCloseIcon?: IconProps;
    desktopWrapper?: InjectableCss;
    containerNishtech?: InjectableCss;
    itemWrapperNishtech?: InjectableCss;
    quickOrderItemWrapperNishtech?: InjectableCss;
    megaMenuGridContainerNishtech?: GridContainerProps;
    megaMenuGridItemNishtech?: GridItemProps;
    megaMenuHeadingNishtech?: LinkPresentationProps;
    menuItemNishtech?: InjectableCss;
    menuItemTypographyNishtech?: TypographyPresentationProps;
    megaMenuNishtech?: PopoverPresentationProps;
}

export const mainNavigationStyles: MainNavigationStyles = {
    menuHeight: 50,
    container: {
        css: css`
            color: ${getColor("common.background")};
            padding: 0 16px 0 45px;
            display: flex;
            justify-content: left;
        `,
    },
    itemWrapper: {
        css: css`
            position: relative;
            overflow: visible;
            display: flex;
            &:hover span + div {
                display: block;
            }
            &:first-child {
                margin-left: -10px;
            }
        `,
    },
    quickOrderItemWrapper: {
        css: css`
            margin-left: auto;
            margin-right: 0;
        `,
    },
    megaMenuGridItem: {
        css: css`
            display: block;
        `,
    },
    megaMenuHeading: {
        css: css`
            font-weight: bold;
            margin-bottom: 8px;
        `,
    },
    menuItem: {
        css: css`
            display: flex;
            align-items: center;
            height: 50px;
            padding: 0 10px;
        `,
    },
    menuItemIcon: {
        css: css`
            margin: -3px 0 0 10px;
        `,
        size: 18,
        color: "secondary.contrast",
    },
    menuItemTypography: {
        variant: "headerSecondary",
        color: "secondary.contrast",
        css: css`
            font-weight: 800;
        `,
    },
    megaMenu: {
        transitionDuration: "short",
        contentBodyProps: {
            _height: "1200px",
            css: css`
                padding: 20px 30px;
            `,
        },
    },
    containerNishtech: {
        css: css`
            color: ${getColor("common.background")};
            padding: 0px;
            display: flex;
            justify-content: left;

            .content-wrap-deals {
                display: flex; 
                .heading{
                    font-weight: bold;
                }
                .label{
                    font-size: 12px;
                    margin-bottom:0;
                }
                .heading,.btn-link{
                    font-size: 12px;
                    &:hover span{
                        color: #006ae3;
                    }
                    span{
                        color: #2d2926;
                    }
                }
                .btn-link span{
                    text-decoration: underline;
                }
            }
            .second-services{
                flex-wrap:wrap;
                
                .content-wrap-deals-dv {
                    max-width: 200px;
                }
            }
            .content-wrap-deals .content-wrap-deals-dv {
                max-width: 254px;
                margin-right:25px;
            }
        `,
    },
    itemWrapperNishtech: {
        css: css`
            position: unset;
            overflow: visible;
            display: flex;
            /* padding-bottom: 30px;
            margin-top: 30px; */
            &:hover span + div {
                display: block;
            }
            /* &:first-child {
                margin-left: -10px;
            } */

            &:nth-child(n-1) > button > span {
                margin: 0px;
            }
        `,
    },
    quickOrderItemWrapperNishtech: {
        css: css`
            margin-left: auto;
            margin-right: 0;
        `,
    },
    megaMenuGridContainerNishtech: {
        css: css`
            margin: 0 auto;
        `,
        offsetCss: css`
            display: flex;
            flex-direction: row;
            padding: 0px;
            border-radius: 0;
            margin: 0px;
            width: 100% !important;
            height: auto;
        `,
    },
    megaMenuGridItemNishtech: {
        css: css`
            display: inline-block !important;
            padding: 10px;
            line-height: 1.125;
            padding: 0.4rem 0rem;
            width: 100%;
            max-width: 100%;
        `,
    },
    megaMenuHeadingNishtech: {
        color: "secondary",
        css: css`
            /* font-family: "sans-serif"; */
            margin-bottom: 0.4rem;
        `,
        typographyProps: {
            size: "14px",
            underline: true,
            css: css`
                &:hover {
                    color: ${getColor("primary")} !important;
                }
            `,
        },
    },
    menuItemNishtech: {
        css: css`
            display: flex;
            align-items: center;
            /* height: 80px; */
            /* padding: 0 8px; */
            position: relative;
            font-weight: 500;
            line-height: normal;
            cursor: default;
            letter-spacing: normal;
            text-decoration: none;
            margin: 0px 22px 0px 0px;
            &:focus {
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                             outline-color:  ${NishtechColors.darkBlack3};      
                             outline-style: solid;
                             outline-width: 0px;
                            `,],
                    "min",);
            }}                  
            }
            &:focus-visible {
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                        outline-color: ${NishtechColors.darkBlack3};    
                        outline-style: ${getProp("theme.focus.style", "solid")};
                        outline-width: 1px;
                        outline-offset: 1px; `,],
                    "min",);
            }}
            } 
            > span {
                color: ${NishtechColors.darkBlue1}!important;
                cursor: pointer;
                font-size: 14px;
                margin: 0px ;
                line-height: normal;
                letter-spacing: normal;
                font-weight: 600;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [
                    null,
                    null,
                    null,
                    css` 
                        position: relative; /* Do not override or modify. Positioning of diagonal mega menu */
                    `,], "min",);
            }}
            }
            & :hover {
                text-decoration: underline ${getColor("text.main")} 4px;
                text-underline-offset: 20px;
            }
            &.menu-item.activeTab {
                text-decoration: underline ${getColor("text.main")} 4px;
                text-underline-offset: 20px;
            }
            /* &.menu-item.activetab {
                text-decoration: underline #020508 4px;
            } */
            ${IconWrapper} {
                margin: -3px 0 0 3px !important;
                width: 18px !important;
                height: 18px !important;

                svg {
                    width: 18px !important;
                    height: 13px !important;
                    font-weight: bold;
                    color: ${NishtechColors.darkBlue1}!important;
                    stroke-width: 3px;
                }
            }
        `,
    },
    menuItemTypographyNishtech: {
        variant: "headerSecondary",
        color: "primary",
        // fontFamily: "sans-serif",
        css: css`
            font-size: 15px;
            text-transform: uppercase;
            font-weight: 500;
            margin: 0 17px 0 0;
        `,
    },
    megaMenuNishtech: {
        transitionDuration: "short",
        contentBodyProps: {
            _height: "1200px",
            css: css`
                padding: 1rem;
                max-width: 100% !important;
                height: auto;
                overflow: hidden !important;
                
            `,
        },
    },
    mobileSearchButton: {
        size: 48,
        buttonType: "solid",
        color: "secondary",
        css: css`
            padding: 0 10px;
        `,
    },
    mobileWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    desktopWrapper: {
        css: css`
        &:focus {
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                        outline-color:  ${getProp("theme.focus.color", "#09f")};       
                        outline-style: solid;
                        outline-width: 0px;
                        `,],
                    "min",);
            }}                  
        }
        &:focus-visible {
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                    outline-color: ${getProp("theme.focus.color", "#09f")};     
                    outline-style: ${getProp("theme.focus.style", "solid")};
                    outline-width: 1px;
                    outline-offset: 1px; `,],
                    "min",);
            }}
        } 
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: block;
                        `,
                        css`
                            display: block;
                        `,
                    ],
                    "min",
                );
            }}
        `,
    },
    compactFlyoutMenu: {
        css: css`
            & button {
                background: transparent;
                border: none;
                &:hover {
                    background: rgba(0, 0, 0, 0.3);
                }

                svg {
                    color: ${props => resolveColor(props.theme.header.linkColor, props.theme)};
                }
            }
        `,
    },
    mobileSearchWrapper: {
        css: css`
            text-align: right;
        `,
    },
    mobileMenuWrapper: {
        css: css`
            text-align: right;
        `,
    },
    mobileSearchInputWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobileSearchInputStyles: {
        input: {
            cssOverrides: {
                formField: css`
                    width: 100%;
                `,
            },
        },
        popover: {
            wrapperProps: {
                css: css`
                    width: calc(100% - 45px);
                `,
            },
        },
        popoverContentBody: {
            as: "div",
            _height: "100%",
            css: css`
                box-shadow: none;
            `,
        },
        autocompleteWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
            `,
        },
        autocompleteColumnWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 0 50px 0 30px;
            `,
        },
        searchHistoryStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    padding: 0 50px 15px 30px;
                `,
            },
        },
        autocompleteProductsStyles: {
            titleLink: {
                css: css`
                    width: 100%;
                `,
            },
            erpNumberText: {
                css: css`
                    width: 100%;
                    text-align: left;
                    margin: 5px 0 0 0;
                `,
            },
        },
    },
    mobileSearchModalCloseIcon: {
        src: X,
        size: 18,
        css: css`
            margin-left: 10px;
        `,
    },
    
};

const defaultCustomCss = `.mobile-wrapper {
}

.mobile-menu-wrapper {
}

.menu-trigger-button {
}

.menu-trigger-button-icon {
}

.drawer {
}

.drawer-section-wrapper {
}

.panel-menu {
}

.main-navigation-row {
}

.panel-section-wrapper {
}

.main-navigation-row-icon {
}

.user-row-text {
}

.punch-out-navigation-row-icon {
}

.punch-out-user-row-text {
}

.main-navigation-row-text {
}

.logo-links-row {
}

.logo-link-title {
}

.language-image {
}

.menu-row-icon {
}

.change-customer-row {
}

.change-customer-row-container {
}

.fulfillment-method-grid-item {
}

.addresses-grid-item {
}

.pick-up-address-grid-item {
}

.apply-button-grid-item {
}

.sign-out-row {
}

.sign-out-row-text {
}

.mobile-search-wrapper {
}

.mobile-search-button {
}

.mobile-search-button-icon {
}

.container {
}

.item-wrapper {
}

.cascading-menu {
}

.menu-item {
}

.mega-menu {
}

.mega-menu-grid-container {
}

.mega-menu-grid-item {
}

.mega-menu-heading-link {
}

.mega-menu-link {
}

.quick-order-item-wrapper {
}

.quick-order-link {
}

.vmi-page-link {
}

.mobile-search-modal {
}`;
export const HandlePlpLinkClickWithHash = () => {
    if(!window) {return}
    const isSearchPage = window.location.pathname.includes("/search")
    if(isSearchPage) {return} 
    
    window.location.hash = ""
}
export class MainNavigation extends React.Component<Props, State> {
    container = React.createRef<HTMLDivElement>();
    mobileSearchInput = React.createRef<HTMLInputElement>();
    declare context: React.ContextType<typeof StylesContext>;

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileSearchModalIsOpen: false,
        };
    }

    UNSAFE_componentWillMount(): void {
        this.loadCategoriesIfNeeded();

        setMainNavigation({
            close: () => {
                this.setState({
                    selectedLinkIndex: undefined,
                });
            },
            openMenu: (index: number) => {
                this.setState({
                    selectedLinkIndex: index,
                });
            },
        });
        const { categoriesDataView, loadCategories } = this.props;

        if ( !categoriesDataView.isLoading && !categoriesDataView.value) {
            loadCategories();
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (!isEqual(this.props.categoryIdsToLoad, prevProps.categoryIdsToLoad)) {
            this.loadCategoriesIfNeeded(true);
        }
    }

    loadCategoriesIfNeeded(isComponentDidUpdate = false) {
        const { categoryIdsToLoad } = this.props;
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!this.props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = categoryIdsToLoad[categoryId];
                if (!this.props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    this.props.loadCategories(getParameter(categoryId, maxDepth));
                }
            }
        }
    }

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };

    render() {
        const {
            links,
            quickOrderLink,
            fields: { showQuickOrder, customCSS,enableCustomMegaMenu },
            id,
            allowQuickOrder,
            isCompactHeaderFlyoutMenu,
            flyoutCustomCSS,
            isCompactHeaderMainNavigation,
            сompactHeaderMainNavigationCustomCSS,
            vmiPageLinks,
            displayVmiNavigation,
            displayModeSwitch,
            currentMode,
            session,
            categories,
            categoriesDataView,
            // toggleLoginDrawer,
            newProductCategory,
        } = this.props;
        const { selectedLinkIndex } = this.state;

        const showQuickOrderLink = showQuickOrder && allowQuickOrder;
        const mainNavContextStyles = this?.context?.styles?.mainNavigation ?? {};
        const styles = mergeToNew(mainNavigationStyles, mainNavContextStyles);
const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
        if (isCompactHeaderFlyoutMenu) {
            const flyoutCustomCssWrapper = {
                css: css`
                    ${flyoutCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...flyoutCustomCssWrapper}>
                    <StyledWrapper className="flyout-menu-wrapper" {...styles.compactFlyoutMenu}>
                        <NavigationDrawer
                            // newProductCategory={newProductCategory as unknown as CustomCategoryModel}
                            links={links}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            isCompactHeaderFlyout={true}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        if (isCompactHeaderMainNavigation) {
            const mainNavigationCustomCSSWrapper = {
                css: css`
                    ${сompactHeaderMainNavigationCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...mainNavigationCustomCSSWrapper}>
                    {displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                {vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <Link
                                                className="vmi-page-link"
                                                key={link.id}
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id={link.id}
                                                href={link.url}
                                            >
                                                {link.title}
                                            </Link>
                                        ),
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                    {!displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            {links.map((link, index) => {
                                return (
                                    <StyledWrapper className="item-wrapper" {...styles.itemWrapper} key={index}>
                                        <MainNavigationItem
                                            index={index}
                                            link={link}
                                            styles={styles}
                                            container={this.container}
                                            isOpen={index === selectedLinkIndex}
                                            displayChangeCustomerLink={this.props.displayChangeCustomerLink} popover={0} isAuth={false} zoneId={""}                                      />
                                    </StyledWrapper>
                                );
                            })}
                            {showQuickOrderLink && quickOrderLink && (
                                <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                    <StyledWrapper
                                        className="quick-order-item-wrapper"
                                        {...styles.quickOrderItemWrapper}
                                    >
                                        <Link
                                            className="quick-order-link"
                                            typographyProps={styles.menuItemTypography}
                                            color={styles.menuItemTypography?.color}
                                            {...styles.menuItem}
                                            id="quickOrder"
                                            href={quickOrderLink.url}
                                        >
                                            {quickOrderLink.title}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            );
        }
        if(enableCustomMegaMenu)
        {
        return (<>
            <Hidden {...styles.desktopWrapper} tabIndex={0}>
                    <StyledWrapper {...styles.containerNishtech} ref={this.container}>
                        {links.map((link, index) => {
                            return (
                                 
                                <StyledWrapper {...styles.itemWrapperNishtech} key={`${index}${link.title}`}>
                                    <MainNavigationItem
                                        zoneId={id}
                                        index={index}
                                        link={link}
                                        styles={styles}
                                        container={this.container}
                                        isOpen={index === selectedLinkIndex}
                                        isAuth={isAuthenticated}
                                        // toggleLogin={toggleLoginDrawer}
                                        displayChangeCustomerLink={this.props.displayChangeCustomerLink} popover={0}                                    />
                                </StyledWrapper>
                                
                            );
                        })}
                        {showQuickOrderLink && quickOrderLink && (
                            <StyledWrapper {...styles.itemWrapperNishtech}>
                                <StyledWrapper {...styles.quickOrderItemWrapper}>
                                    <Link
                                        typographyProps={styles.menuItemTypographyNishtech}
                                        color={styles.menuItemTypographyNishtech?.color}
                                        {...styles.menuItemNishtech}
                                        id="quickOrder"
                                        href={quickOrderLink.url}
                                        onClick={HandlePlpLinkClickWithHash}
                                    >
                                        {quickOrderLink.title}
                                    </Link>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </Hidden>
                    <Hidden above="md" >
                        <StyledWrapper {...styles.containerNishtech} ref={this.container} className="custom-mobile-menu">
                       <ul className="as-nav">
                            {!displayVmiNavigation && (links.map((link, index) => {
                                return (
                                    <li key={`level0${index}`} className={(link.children?.length ? (link.isCalloutMenu ? "as-nav-item as-dropdown-wrap-alt" : "as-nav-item") :"")} >
                                        {(link.children && link.children.length) && (<a href={link.url} className="level1 as-opener">{link.title}</a>)}
                                        {!(link.children && link.children.length) && (<a href={link.url} className="level1 no-opener">{link.title}</a>)}
                                        {(link.children && link.children.length) && (
                                            <>
                                                <div className="as-dropdown extra"></div>
                                                <div className="as-dropdown">
                                                    <div className="as-dropdown-wrap">
                                                        <a href="#" className="as-back-btn as-opener">back</a>
                                                        <span className="as-menu-title level1">{link.title}</span>
                                                        <ul>
                                                            {link.children?.map((level1link: { children: { children: { url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }[]; url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }[]; url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }, level1index: any) => {
                                                                return (
                                                                    <li key={`level1${level1index}`} className={level1link.children && level1link.children.length > 0 ? "as-sub-nav-item" : ""}>
                                                                        {!(level1link.children && level1link.children.length) && (<a href={level1link.url} className="level2" >{level1link.title}</a>)}
                                                                        {level1link.children && level1link.children.length > 0 && (<>
                                                                            <a href={level1link.url} className="level2 as-sub-opener" >{level1link.title}</a>
                                                                            <div className="as-sub-dropdown">
                                                                                <a href="#" className="as-back-btn as-sub-opener">back</a>
                                                                                <span className="as-menu-title">{link.title}</span>
                                                                                <span className="as-menu-sub-title level2">{level1link.title}</span>
                                                                                <ul>
                                                                                    {level1link.children?.map((level2link: { children: { url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }[]; url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }, level2index: any) => {
                                                                                        return (<>
                                                                                            {!(level2link.children && level2link.children.length) && <li key={`level2${level2index}`}>
                                                                                                <a href={level2link.url} className="level3 no-opener">{level2link.title}</a>
                                                                                            </li>}
                                                                                            {level2link.children && level2link.children.length > 0 && <li key={`level2${level2index}`} className="as-sub-sub-nav-item">
                                                                                                <a href={level2link.url} className="as-sub-sub-opener">{level2link.title}</a>
                                                                                                <div className="as-sub-sub-dropdown">
                                                                                                    <a href="#" className="as-back-btn as-sub-sub-opener">back</a>
                                                                                                    <span className="as-menu-title">{link.title}</span>
                                                                                                    <span className="as-menu-sub-title">{level1link.title}</span>
                                                                                                    <span className="as-menu-sub-title">{level2link.title}</span>
                                                                                                    <ul>
                                                                                                        {level2link.children?.map((level3link: { url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }, level3index: any) => {
                                                                                                            return (<>
                                                                                                                <li key={`level3${level3index}`}><a href={level3link.url}>{level3link.title}</a></li>
                                                                                                            </>)
                                                                                                        })}
                                                                                                    </ul>
                                                                                                </div>

                                                                                            </li>}


                                                                                        </>
                                                                                        )
                                                                                    })}
                                                                                </ul>
                                                                            </div>
                                                                        </>
                                                                        )}
                                                                    </li>
                                                                );
                                                            })}

                                                        </ul>
                                                        {link.hasCalloutBox &&
                                                            <a href="#" className="as-call-out-box">
                                                                <strong className="as-ttl">{link.callOutTitle}</strong>
                                                                <span className="as-text">{link.callOutText && parse(link.callOutText, parserOptions)}</span>
                                                            </a>
                                                        }
                                                    </div>
                                                </div>
                                            </>)
                                        }
                                    </li>
                                )
                            }))}
                            {showQuickOrderLink && quickOrderLink && (
                                <li key={links.length}>
                                    <a href={quickOrderLink.url} className="level1 no-opener">{quickOrderLink.title}</a>
                                </li>
                            )}
                        </ul>     
                    </StyledWrapper></Hidden></>)
        }
        
        const customCssWrapper = {
            css: css`
                ${customCSS}
            `,
        };

        return (<>
            <ul className="as-nav">
                {!displayVmiNavigation && (links.map((link, index) => {
                    return (
                        <li key={`level0${index}`} className={(link.children?.length ? (link.isCalloutMenu ? "as-nav-item as-dropdown-wrap-alt" : "as-nav-item") :"")} >
                            {(link.children && link.children.length) && (<a href={link.url} className="level1 as-opener">{link.title}</a>)}
                            {!(link.children && link.children.length) && (<a href={link.url} className="level1 no-opener">{link.title}</a>)}
                            {(link.children && link.children.length) && (
                                <>
                                    <div className="as-dropdown extra"></div>
                                    <div className="as-dropdown">
                                        <div className="as-dropdown-wrap">
                                            <a href="#" className="as-back-btn as-opener">back</a>
                                            <span className="as-menu-title level1">{link.title}</span>
                                            <ul>
                                                {link.children?.map((level1link: { children: { children: { url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }[]; url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }[]; url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }, level1index: any) => {
                                                    return (
                                                        <li key={`level1${level1index}`} className={level1link.children && level1link.children.length > 0 ? "as-sub-nav-item" : ""}>
                                                            {!(level1link.children && level1link.children.length) && (<a href={level1link.url} className="level2" >{level1link.title}</a>)}
                                                            {level1link.children && level1link.children.length > 0 && (<>
                                                                <a href={level1link.url} className="level2 as-sub-opener" >{level1link.title}</a>
                                                                <div className="as-sub-dropdown">
                                                                    <a href="#" className="as-back-btn as-sub-opener">back</a>
                                                                    <span className="as-menu-title">{link.title}</span>
                                                                    <span className="as-menu-sub-title level2">{level1link.title}</span>
                                                                    <ul>
                                                                        {level1link.children?.map((level2link: { children: { url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }[]; url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }, level2index: any) => {
                                                                            return (<>
                                                                                {!(level2link.children && level2link.children.length) && <li key={`level2${level2index}`}>
                                                                                    <a href={level2link.url} className="level3 no-opener">{level2link.title}</a>
                                                                                </li>}
                                                                                {level2link.children && level2link.children.length > 0 && <li key={`level2${level2index}`} className="as-sub-sub-nav-item">
                                                                                    <a href={level2link.url} className="as-sub-sub-opener">{level2link.title}</a>
                                                                                    <div className="as-sub-sub-dropdown">
                                                                                        <a href="#" className="as-back-btn as-sub-sub-opener">back</a>
                                                                                        <span className="as-menu-title">{link.title}</span>
                                                                                        <span className="as-menu-sub-title">{level1link.title}</span>
                                                                                        <span className="as-menu-sub-title">{level2link.title}</span>
                                                                                        <ul>
                                                                                            {level2link.children?.map((level3link: { url: string | undefined; title: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }, level3index: any) => {
                                                                                                return (<>
                                                                                                    <li key={`level3${level3index}`}><a href={level3link.url}>{level3link.title}</a></li>
                                                                                                </>)
                                                                                            })}
                                                                                        </ul>
                                                                                    </div>

                                                                                </li>}


                                                                            </>
                                                                            )
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </>
                                                            )}
                                                        </li>
                                                    );
                                                })}

                                            </ul>
                                            {link.hasCalloutBox &&
                                                <a href="#" className="as-call-out-box">
                                                    <strong className="as-ttl">{link.callOutTitle}</strong>
                                                    <span className="as-text">{link.callOutText && parse(link.callOutText, parserOptions)}</span>
                                                </a>
                                            }
                                        </div>
                                    </div>
                                </>)
                            }
                        </li>
                    )
                }))}
                {showQuickOrderLink && quickOrderLink && (
                    <li key={links.length}>
                        <a href={quickOrderLink.url} className="level1 no-opener">{quickOrderLink.title}</a>
                    </li>
                )}
            </ul>
        </>
        );

        
}
}


MainNavigation.contextType = StylesContext;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const mainNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MainNavigation),
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    const { type, value } = item.fields.destination;
                    const { overrideTitle, title } = item.fields;
                    const disabledMegaMenuName = item.fields;
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return overrideTitle || link?.title;
                    }
                    if (type === "Category") {
                        if (overrideTitle) {
                            return overrideTitle;
                        }
                        if (value === emptyGuid) {
                            return "Products";
                        }
                        const categoryState = getCategoryState(state, value);
                        if (!categoryState.value) {
                            if (!categoryState.isLoading && value) {
                                return dispatch => {
                                    dispatch(
                                        loadCategory({
                                            id: value,
                                        }),
                                    );
                                };
                            }
                            return "";
                        }
                        return categoryState.value.shortDescription;
                    }
                    if (type === "Url") {
                        return title ?? value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "linkType",
                        editorTemplate: "RadioButtonsField",
                        defaultValue: "Link",
                        isRequired: true,
                        options: [
                            {
                                displayName: "Link",
                                value: "Link",
                            },
                            {
                                displayName: "Mega Menu",
                                value: "MegaMenu",
                            },
                            {
                                displayName: "Cascading Menu",
                                value: "CascadingMenu",
                            },
                        ],
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                        allowUrls: item => item.fields.linkType === "Link",
                        showCategoryRoot: item => true,
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.destination.type !== "Url",
                    },
                    {
                        name: "megaMenuName",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === "CascadingMenu" || item.fields.linkType === "MegaMenu",
                        isEnabled: item => item?.fields.disabledMegaMenuName === false,
                    },
                    {
                        name: "isCustomMegaMenu",
                         editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === "CascadingMenu" || item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "megaMenuType",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.isCustomMegaMenu === true,
                    },
                    {
                        name: "megaMenuWidth",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.isCustomMegaMenu === true,
                    },
                    {
                        name: "megaMenuHeight",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.isCustomMegaMenu === true,
                    },
                    {
                        name: "allowMultipleWidget",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: item => item.fields.megaMenuType === "AllCategoryWithWidget",
                    },
                    {
                        name: "firstContainerWidth",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.megaMenuType === "AllCategoryWithWidget",
                    },
                    {
                        name: "secondContainerWidth",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.megaMenuType === "AllCategoryWithWidget",
                    },
                    {
                        name: "thirdContainerWidth",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.megaMenuType === "AllCategoryWithWidget",
                    },
                    {
                        name: "disabledMegaMenuName",
                        displayName: "Please Don't Click",
                        editorTemplate: "CheckboxField",
                        defaultValue: true,
                        tooltip:
                            "(By checking the checkbox, the Mega Menu Name field will be enabled and a distinct value can be set that can be used to uniquely identify a specific menu. If the mega menu name field is already populated please don't change it.)",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                        isVisible: item => item.fields.destination.type === "Url",
                    },
                    {
                        name: "numberOfColumns",
                        editorTemplate: "DropDownField",
                        defaultValue: 6,
                        options: [{ value: 2 }, { value: 3 }, { value: 4 }, { value: 6 }],
                        isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "maxDepth",
                        editorTemplate: "DropDownField",
                        defaultValue: 3,
                        options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
                        isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === "CascadingMenu"  || item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "Link",
                    },
                    {
                        name: "isCalloutMenu",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "hasCalloutBox",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "callOutTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: false,
                        isVisible: item => item.fields.hasCalloutBox === true,
                    },
                    {
                        name: "callOutText",
                        editorTemplate: "RichTextField",
                        defaultValue: "",
                        isRequired: false,
                        isVisible: item => item.fields.hasCalloutBox === true,
                    },
                    {
                        name: "isLoggedInRequired",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "Link",
                    },
                    {
                        name: "mergedTwoCategoryIntoOne",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === "CascadingMenu" || item.fields.linkType === "MegaMenu",
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.showQuickOrder,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.enableCustomMegaMenu,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            
        ],
    },
};

export default mainNavigation;
